import { render, staticRenderFns } from "./cooperativehistory.vue?vue&type=template&id=76fe85ce&scoped=true"
import script from "./cooperativehistory.vue?vue&type=script&lang=js"
export * from "./cooperativehistory.vue?vue&type=script&lang=js"
import style0 from "./cooperativehistory.vue?vue&type=style&index=0&id=76fe85ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fe85ce",
  null
  
)

export default component.exports